<template>
  <div id="app">
    <router-view/>
    <div id="modal-destination"></div>
  </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>
